export default {
    title: {
        new: "Új cím hozzáadása",
        complete: "Teljes cím",
        edit: "Cím szerkesztése"
    },
    incomplete: "Kérjük, töltse ki a kötelező címmezőket",
    info: {
        "CHN": "Kérjük, adja meg a címét kínaiul.</br> Kérjük, adja meg a címét kínaiul.",
        "BGR": "Add meg <b>a lakcímedet</b> angolul, hogy megkaphasd a csomagjaidat.",
        "PRI": "Csomagok átvételéhez kérjük, a lakcímét adja meg, ne postafiókot.",
        "SGP": "Kérjük, a címben tüntesse fel a lakásszámát is.",
        "SVK": "Kérjük, adja meg címét <b>angolul</b>",
        "POL": "Kérjük, adja meg címét <b>angolul</b>"
    },
    model: {
        country: {
            label: "Ország"
        }
    },
    field: {
        default: {
            "name": {
                "label": {
                    "Name": "Név"
                },
                "placeholder": {
                    "Name": "Név",
                    "Name in English": "Név angolul"
                }
            },
            personalEmail: {
                label: {
                    "Personal Email": "Személyes e-mail"
                },
                placeholder: {
                    "Personal Email": "Személyes e-mail"
                }
            },
            managerEmail: {
                label: {
                    "Manager Email": "Vezető e-mail címe"
                },
                placeholder: {
                    "Manager Email": "Vezető e-mail címe"
                }
            },
            managerName: {
                label: {"Manager Name": "Menedzser neve"},
                placeholder: {"Manager Name": "Menedzser neve"}
            },
            "postalCode": {
                "label": {
                    "Zipcode": "Irányítószám",
                    "Post Code": "Irányítószám",
                    "Postal Code": "Irányítószám",
                    "CPA": "CPA"
                },
                "placeholder": {
                    "Zipcode": "Irányítószám",
                    "Post Code": "Irányítószám",
                    "Postal Code": "Irányítószám",
                    "CPA": "CPA"
                }
            },
            "province": {
                "label": {
                    "Province": "Tartomány",
                    "Prefecture": "Prefektúra",
                    "Province/Region": "Tartomány/Régió",
                    "Province Code": "Tartomány kódja"
                },
                "placeholder": {
                    "Province": "Tartomány",
                    "Prefecture": "Prefektúra",
                    "Province/Region": "Tartomány/Régió",
                    "Province Code": "Tartomány kódja"
                }
            },
            "phoneNumber": {
                "label": {
                    "Phone Number": "Telefonszám"
                },
                "placeholder": {
                    "Phone Number": "Telefonszám"
                }
            },
            "secondaryPhoneNumber": {
                "label": {"Secondary Phone Number": "Másodlagos telefonszám"},
                "placeholder": {"Secondary Phone Number": "Másodlagos telefonszám"}
            },
            "firstStreet": {
                "label": {
                    "Street": "Utca",
                    "Tax ID": "Adóazonosító"
                },
                "placeholder": {
                    "Street": "Utca",
                    "Street in English": "Utca angolul",
                    "Tax ID (RUT)": "Adóazonosító (RUT)",
                    "Number/Street/Apartment": "Házszám/Utca/Lakás"
                }
            },
            "secondStreet": {
                "label": {
                    "District": "Kerület",
                    "Colonia": "Köln",
                    "Canton": "Kanton",
                    "Street": "Utca"
                },
                "placeholder": {
                    "District": "Kerület",
                    "Colonia": "Köln",
                    "Canton": "Kanton",
                    "Number/Street/Apartment": "Házszám/Utca/Lakás"
                }
            },
            "city": {
                "label": {
                    "City": "Város",
                    "Town/City/Locality": "Város/Község/Község",
                    "Town/City": "Város",
                    "City/Municipality/Locality": "Város/Község/Község",
                    "City/Town/Locality": "Város/Község/Község",
                    "City/Town": "Város/Község",
                    "District": "Kerület",
                    "City/Town/Locallity": "Város/Község/Község",
                    "Town/City/Sub Locality": "Város/Község/Község"
                },
                "placeholder": {
                    "City": "Város",
                    "Town/City": "Város",
                    "Town/City/Locality": "Város/Község/Község",
                    "City/Municipality/Locality": "Város/Község/Község",
                    "City/Town/Locality": "Város/Község/Község",
                    "City/Town in English": "Város/település angolul",
                    "District": "Kerület",
                    "City/Town/Locallity": "Város/Község/Község",
                    "Town/City/Sub Locality": "Város/Község/Község"
                }
            },
            identifier: {
                label: {
                    "identifier": "Azonosító",
                    "Identifier": "Azonosító"
                },
                placeholder: {
                    "identifier": "Azonosító",
                    "Identifier": "Azonosító"
                }
            },
            "region": {
                "label": {
                    "Region": "Régió",
                    "County": "Megye",
                    "Locality": "Helység"
                },
                "placeholder": {
                    "Region": "Régió",
                    "County": "Megye",
                    "Locality": "Helység"
                }
            },
            "poBox": {
                "label": {
                    "PO BOX": "Postafiók"
                },
                "placeholder": {
                    "PO BOX": "Postafiók"
                }
            },
            state: {
                "label": {
                    "State": "Állami",
                    "Province/Region": "Tartomány/Régió",
                    "Province": "Tartomány",
                    "Department": "Osztály",
                    "Municipality/Comuna": "Község"
                },
                "placeholder": {
                    "State": "Állami",
                    "Province/Region": "Tartomány/Régió",
                    "Province": "Tartomány",
                    "Department": "Osztály",
                    "Municipality/Comuna": "Község"
                },
                options: {
                    "Alabama": "Alabama",
                    "Alaska": "Alaszka",
                    "Arizona": "Arizona",
                    "Arkansas": "Arkansas",
                    "California": "Kalifornia",
                    "Colorado": "Colorado",
                    "Connecticut": "Connecticut",
                    "Delaware": "Delaware",
                    "District Of Columbia": "Columbiai Kerület",
                    "Florida": "Florida",
                    "Georgia": "Grúzia",
                    "Hawaii": "Hawaii",
                    "Idaho": "Idaho",
                    "Illinois": "Illinois",
                    "Indiana": "Indiana",
                    "Iowa": "Iowa",
                    "Kansas": "Kansas",
                    "Kentucky": "Kentucky",
                    "Louisiana": "Louisiana",
                    "Maine": "Maine",
                    "Maryland": "Maryland",
                    "Massachusetts": "Massachusetts",
                    "Michigan": "Michigan",
                    "Minnesota": "Minnesota",
                    "Mississippi": "Mississippi",
                    "Missouri": "Missouri",
                    "Montana": "Montana",
                    "Nebraska": "Nebraska",
                    "Nevada": "Nevada",
                    "New Hampshire": "New Hampshire",
                    "New Jersey": "New Jersey",
                    "New Mexico": "Új-Mexikó",
                    "New York": "New York",
                    "North Carolina": "Észak-Karolina",
                    "North Dakota": "Észak-Dakota",
                    "Ohio": "Ohio",
                    "Oklahoma": "Oklahoma",
                    "Oregon": "Oregon",
                    "Pennsylvania": "Pennsylvania",
                    "Rhode Island": "Rhode Island",
                    "South Carolina": "Dél-Karolina",
                    "South Dakota": "Dél-Dakota",
                    "Tennessee": "Tennessee",
                    "Texas": "Texas",
                    "Utah": "Utah",
                    "Vermont": "Vermont",
                    "Virginia": "Virginia",
                    "Washington": "Washington",
                    "West Virginia": "Nyugat-Virginia",
                    "Wisconsin": "Wisconsin",
                    "Wyoming": "Wyoming"
                }
            },
            "deliveryInstructions": {
                "label": {
                    "Delivery Instructions": "Szállítási utasítások"
                },
                "placeholder": {
                    "Extra address information, delivery instructions, etc. ": "További címinformációk, szállítási utasítások stb. ",
                    "Extra address information, delivery instructions, etc. in English ": "További címinformációk, szállítási utasítások stb. angolul ",
                    "Extra address information, delivery instructions, etc": "További címinformációk, szállítási utasítások stb."
                }
            },
        },
        BRA: {
            name: {
                label: {"Full name": "Teljes név"},
                placeholder: {"Full name": "Teljes név"}
            },
            firstStreet: {
                label: {"Address 1": "1. cím"},
                placeholder: {"Address 1": "Utca + házszám/lakásszám"}
            },
            secondStreet: {
                label: {
                    "Address 2": "2. cím",
                    "District": "Kerület"
                },
                placeholder: {
                    "Address 2": "Utca + házszám/lakásszám",
                    "District": "Kerület"
                }
            },
            city: {
                label: {City: "Város"},
                placeholder: {City: "Város"},
            },
            state: {
                label: {State: "Állami"},
                placeholder: {State: "Állami"}
            },
            "postalCode": {
                "label": {
                    "Zipcode": "Irányítószám",
                    "Post Code": "Irányítószám",
                    "Postal Code": "Irányítószám",
                    "CPA": "CPA"
                },
                "placeholder": {
                    "Zipcode": "Irányítószám",
                    "Post Code": "Irányítószám",
                    "Postal Code": "Irányítószám",
                    "CPA": "CPA"
                }
            },
            identifier: {
                "label": {
                    "Tax ID": "Adóazonosító"
                },
                "placeholder": {
                    "Tax ID (CDI, CUIT, CUIL, etc)": "Adóazonosító (CDI, CUIT, CUIL stb.)"
                }
            }
        },
        IND: {
            state: {
                label: {"State/Territory": "Állam/Terület"},
                options: {
                    "Andaman and Nicobar Islands": "Andamán- és Nikobár-szigetek",
                    "Arunachal Pradesh": "Arunachal Pradesh",
                    "Assam": "Assam",
                    "Bihar": "Bihár",
                    "Chandigarh": "Csandígarh",
                    "Chhattisgarh": "Cshattíszgarh",
                    "Dadra and Nagar Haveli and Daman and Diu": "Dadra és Nagar Haveli, valamint Daman és Diu",
                    "Delhi": "Delhi",
                    "Goa": "Goa",
                    "Gujarat": "Gudzsarát",
                    "Haryana": "Harijána",
                    "Himachal Pradesh": "Himachal Pradesh",
                    "Jammu and Kashmir": "Dzsammu és Kasmír",
                    "Jharkhand": "Dzshárkhand",
                    "Karnataka": "Karnátaka",
                    "Kerala": "Kerala",
                    "Ladakh":"Ladakh",
                    "Lakshadweep": "Lakshadweep",
                    "Madhya Pradesh": "Madhya Pradesh",
                    "Maharashtra": "Mahárástra",
                    "Manipur": "Manipur",
                    "Meghalaya": "Meghalaya",
                    "Mizoram": "Mizoram",
                    "Nagaland": "Nagaland",
                    "Odisha": "Odisha",
                    "Puducherry": "Puducherry",
                    "Punjab": "Pandzsáb",
                    "Rajasthan": "Rádzsasztán",
                    "Sikkim": "Szikkim",
                    "Tamil Nadu": "Tamilnádu",
                    "Telangana":"Telangana",
                    "Tripura": "Tripura",
                    "Uttar Pradesh": "Uttar Pradesh",
                    "Uttarakhand": "Uttarakhand",
                    "West Bengal": "Nyugat-Bengál",
                    "Andhra Pradesh": "Ándhra Prades"
                }
            }
        }
    },
    errors: {
        required: "A {field} karakterlánc megadása kötelező.",
        mask: "A {field} érvénytelen."
    },
    buttons: {
        submit: {
            text: "Megtakarítás",
            saving: "Megtakarítás"
        },
        cancel: {
            text: "Mégsem"
        }
    },
    disclaimer: "A cím hozzáadásához e-mail cím megerősítése szükséges. A cím mentése után kérjük, ellenőrizze e-mailjeit, és kattintson a benne található linkre.",
    message: {
        added: "Cím hozzáadva",
        updated: "A cím frissítve lett"
    }
}